





























































































































































import Vue from "vue";
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import Chat from "../components/detail/Chat.vue";
import BiddingLog from "../components/detail/BiddingLog.vue";
import TimeBar from "../components/detail/TimeBar.vue";
import { itemApi, auctionApi } from "../utils/axios";
import { AxiosResponse } from "axios";
import numberWithCommas from "../utils/numberWithCommas";

export default Vue.extend({
  name: "Product",
  components: {
    Chat,
    BiddingLog,
    TimeBar,
  },

  data: () => ({
    seller: false,
    item: {},
    itemId: -1,
    nowPrice: -1,
    nextPrice: -1,
    happyPrice: -1,
    sellerId: -1,
    biddingLog: new Array<String>(),
    dialog: false,
    stompClient: Stomp.over(new SockJS(`${process.env.VUE_APP_API_SERVER}/ws`)),
  }),
  filters: {
    comma(val: number | string) {
      return numberWithCommas(Number(val));
    },
  },
  computed: {
    user (): any {
      if (this.$store.state.userModule.user !== null) {
        return this.$store.state.userModule.user.object.user;
      }
      return null;
    },
    isOver (): boolean {
      if (this.biddingLog.length === 0) {
        return false;
      }
      return this.happyPrice === Number(this.biddingLog[0].split(';')[1])
    }
  },
  watch: {
    // biddingLog() {
    //   console.log('watched!')
    //   if (this.happyPrice === Number(this.biddingLog[0].split(';')[1])) {
    //     this.isOver = true;
    //   }
    // }
  },
  methods: {
    async getItem(id: number) {
      await itemApi.getItem(id).then((res: AxiosResponse) => {
        this.item = res.data.object;
        this.itemId = res.data.object.itemId;
        this.happyPrice = res.data.object.happyPrice;
        this.nextPrice = res.data.object.nextPrice;
        this.nowPrice = res.data.object.nowPrice;
        if (!this.$store.state.userModule.user) {
          // alert("로그인을 해주세요.");
        }
        else if (Number(this.$store.state.userModule.user.object.user.id) === Number(res.data.object.sellerId)) {
          this.seller = true;
          console.log(this.seller)
        }
      })
      // 404 처리
      // .catch(() => this.$router.replace({ path: '/404' }));
    },
    connect () {
      // socket 연결
      this.stompClient.connect(
        {},
        () => {
          // server 옥션 메세지 전송 endpoint 구독하기
          this.stompClient.subscribe(`/topic/auction/${this.itemId}`, res => {
            // nowPrice, nextPrice 업데이트
            console.log('auction subscribed!!!')
            const info = JSON.parse(res.body).content
            // log 업데이트
            this.biddingLog.unshift(info.log);
            this.nowPrice = info.nowPrice;
            this.nextPrice = info.nextPrice;
            // console.log(info)
            // if (info.test !== undefined) {
            //   this.log()
            // }
          });
        },
        // socket 연결 실패
        err => {
          console.log(err);
        })
    },
    bid() {
      // 마감 확인
      if (!this.isOver) {
        if (localStorage.getItem("user") && this.stompClient) {
          const bidInfo = {
            sender: this.user.id,
            content: this.itemId,
            type: "AUCTION"
          };
          // socket으로 전송
          this.stompClient.send(`/app/auction.sendMessage/${this.itemId}`, {}, JSON.stringify(bidInfo));
        } else {
          alert("로그인 해주세요!");
        }
      } else {
        alert("마감되었습니다.")
      }
    },
    flex() {
      // 마감 확인
      if (!this.isOver) {
        if (localStorage.getItem("user") && this.stompClient) {
          const flexInfo = {
            sender: this.user.id,
            content: this.itemId,
            type: "FLEX"
          };
          this.stompClient.send(`/app/auction.sendMessage/${this.itemId}`, {}, JSON.stringify(flexInfo));
        } else {
          alert("로그인 해주세요!");
        }
        this.dialog = false;
      } else {
        alert("마감되었습니다.")
      }
    },
    log() {
      // 응찰 내역 불러오기
      auctionApi.log(Number(this.$route.params.id)).then((res: AxiosResponse) => {
          this.biddingLog = res.data.object.log.reverse();
          // console.log(this.biddingLog);
        })
        .catch(() => {
          this.biddingLog = [];
        });
      },
    },
  created() {
    // id번 detail정보 가져오기
    const id = Number(this.$route.params.id);
    this.getItem(id);
    // socket 연결
    // 응찰 내역
    this.log();
    this.connect();
  },
});
